var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Config } from "../Config";
import { FaceTecSDK } from "../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { SessionRequestProcessor } from "./processors/SessionRequestProcessor";
import { MigrationProcessor } from "./processors/MigrationProcessor";
import { SampleAppUtilities } from "./utilities/SampleAppUtilities";
import { DeveloperStatusMessages } from "./utilities/DeveloperStatusMessages";
import { FaceTecStatusEnumFriendlyText } from "./utilities/FaceTecStatusEnumFriendlyText";
import { UserFriendlyMessages } from "./utilities/UserFriendlyMessages";
import { FACETEC_SPANISH_STRINGS, FACETEC_OCR_SPANISH } from "./utilities/SpanishLocalization";
export var FacetecApp = (function () {
    var latestExternalDatabaseRefID = "";
    var faceTecSDKInstance;
    var isInitialized = false;
    var pendingInitializationActions = [];
    var currentTriggerFlow = ""; // Track current flow for cancel logging
    // Helper: mantiene en window.__currentTriggerFlow el flujo activo para que los
    // processors del SDK (SessionRequestProcessor / MigrationProcessor) puedan
    // etiquetar los logs de captura con el flujo correcto sin tener que pasarles
    // el dato por constructor.
    function setCurrentTriggerFlow(flow) {
        currentTriggerFlow = flow;
        try {
            window.__currentTriggerFlow = flow;
        }
        catch ( /* noop */_a) { /* noop */ }
    }
    var retryCount = 0;
    var MAX_RETRIES = 2; // Máximo de reintentos automáticos (solo para cancelación fantasma)
    var RETRY_DELAY_MS = 1500;
    // Solo cancelaciones en la pantalla Ready / primeros segundos, SIN retry de calidad.
    // 15s metía sesiones reales (luz/encuadre) y el auto-retry parecía "se canceló solo".
    var PHANTOM_THRESHOLD_MS = 4000;
    var sessionStartTime = 0;
    function markSessionStarted() {
        sessionStartTime = Date.now();
        try {
            window.__sdkRetryScreenCount = 0;
        }
        catch ( /* noop */_a) { /* noop */ }
    }
    function getSdkRetryScreenCount() {
        try {
            return Number(window.__sdkRetryScreenCount) || 0;
        }
        catch (_a) {
            return 0;
        }
    }
    // Helper: envía evento al sistema unificado de tracking (BasicComponent.enviarLog).
    // Se usa función dinámica porque enviarLog se expone en window al montar BasicComponent;
    // si por alguna razón aún no está disponible, registramos un warn pero no rompemos el flujo.
    function logEvent(event, extra) {
        if (extra === void 0) { extra = {}; }
        try {
            var fn = window.enviarLog;
            if (typeof fn === 'function') {
                fn(event, extra);
            }
            else {
                console.warn("\u26A0\uFE0F [Log] window.enviarLog no disponible para evento '".concat(event, "'"));
            }
        }
        catch (e) {
            console.error("\u274C [Log] Error enviando '".concat(event, "':"), e);
        }
    }
    function serializeErrorForLog(err) {
        if (!err)
            return { message: String(err) };
        if (err instanceof Error) {
            return { name: err.name, message: err.message, stack: err.stack };
        }
        if (typeof err === 'object') {
            try {
                return JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err)));
            }
            catch (_a) {
                return { message: String(err) };
            }
        }
        return { message: String(err) };
    }
    /**
     * Detecta el entorno de ejecución para distinguir testing local de producción móvil.
     * En producción, esta página se carga dentro de la WebView de Flutter (móvil);
     * en testing local se abre en Chrome/Edge desktop.
     *
     * Permite que eventos como "flutter_bridge_unavailable" se reporten con el nivel
     * adecuado: 'info' en testing desktop (esperado, no es error real) y 'error' en
     * móvil (es un fallo crítico — la app de Flutter no recibirá el callback).
     */
    function detectEnvironment() {
        var ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
        var isMobileUA = /Android|iPhone|iPad|iPod/i.test(ua);
        // Heurísticas comunes para detectar WebView in-app:
        //  - Android WebView pone "; wv)" en el UA.
        //  - flutter_inappwebview a veces inyecta marcadores propios en el UA.
        //  - iOS WebView no tiene "Version/X Safari" como Safari estándar.
        var isLikelyWebView = /;\s*wv\)/i.test(ua) ||
            /Flutter/i.test(ua) ||
            (/iPhone|iPad|iPod/i.test(ua) && !/Version\/[\d.]+\s+Safari/.test(ua));
        return {
            userAgent: ua,
            isMobileUA: isMobileUA,
            isLikelyWebView: isLikelyWebView,
            // Esperamos que el bridge exista cuando la página corre en móvil
            // (en producción Flutter siempre la abre dentro de su WebView).
            expectedFlutterBridge: isMobileUA || isLikelyWebView
        };
    }
    // Wait for onload to be complete before attempting to access the Browser SDK.
    window.onload = function () {
        // URLs versionadas por BUILD_ID (inyectado en index.html). Tras el deploy de CSP
        // el WebView Android cacheó el .wasm con Cache-Control:immutable; versionar la
        // carpeta fuerza una URL nueva y evita ResourcesCouldNotBeLoadedOnLastInit (4).
        // En local (sin Docker) __FACETEC_ASSET_VER__ queda como placeholder → rutas sin sufijo.
        var assetVer = (typeof window !== 'undefined' && window.__FACETEC_ASSET_VER__) || '';
        var useVersioned = !!assetVer && assetVer !== '__BUILD_ID__';
        var resourcesDir = useVersioned
            ? "/core-sdk/FaceTecSDK.js/resources_".concat(assetVer)
            : '/core-sdk/FaceTecSDK.js/resources';
        var imagesDir = useVersioned
            ? "/core-sdk/FaceTec_images_".concat(assetVer)
            : '/core-sdk/FaceTec_images';
        console.log('📦 [FaceTec] Resource dirs:', { resourcesDir: resourcesDir, imagesDir: imagesDir, assetVer: assetVer || '(local)' });
        FaceTecSDK.setResourceDirectory(resourcesDir);
        FaceTecSDK.setImagesDirectory(imagesDir);
        try {
            window.__FACETEC_IMAGES_DIR__ = imagesDir + '/';
        }
        catch (e) { /* noop */ }
        // Initialize FaceTec Browser SDK and configure the UI features.
        FaceTecSDK.initializeWithSessionRequest(Config.DeviceKeyIdentifier, new SessionRequestProcessor(generateExternalDatabaseRefID(), onComplete), {
            onSuccess: function (newFaceTecSdkInstance) {
                faceTecSDKInstance = newFaceTecSdkInstance;
                SampleAppUtilities.enableAllButtons();
                onFaceTecSDKInitializationSuccess();
                isInitialized = true;
                flushPendingInitializationActions();
            },
            onError: onFaceTecSDKInitializationFailure
        });
        SampleAppUtilities.formatUIForDevice();
    };
    // Finish setup after initialization success
    function onFaceTecSDKInitializationSuccess() {
        console.log("FaceTec SDK was initialized successfully.");
        // Aplicar localización en español
        try {
            FaceTecSDK.configureLocalization(FACETEC_SPANISH_STRINGS);
            FaceTecSDK.configureOCRLocalization(FACETEC_OCR_SPANISH);
            console.log("✅ Localización en español aplicada exitosamente");
        }
        catch (error) {
            console.error("❌ Error aplicando localización:", error);
        }
        // Aplicar customización personalizada
        try {
            var customization = Config.retrieveConfigurationWizardCustomization(FaceTecSDK);
            var lowLightCustomization = Config.retrieveLowLightConfigurationWizardCustomization(FaceTecSDK);
            var dynamicDimmingCustomization = Config.retrieveDynamicDimmingConfigurationWizardCustomization(FaceTecSDK);
            FaceTecSDK.setCustomization(customization);
            FaceTecSDK.setLowLightCustomization(lowLightCustomization);
            FaceTecSDK.setDynamicDimmingCustomization(dynamicDimmingCustomization);
            console.log("✅ Customización aplicada exitosamente (normal, low-light, dynamic-dimming)");
        }
        catch (error) {
            console.error("❌ Error aplicando customización:", error);
        }
        SampleAppUtilities.displayStatus("Inicializado Exitosamente.");
    }
    ;
    function flushPendingInitializationActions() {
        if (pendingInitializationActions.length === 0) {
            return;
        }
        var actionsToRun = pendingInitializationActions.slice();
        pendingInitializationActions = [];
        actionsToRun.forEach(function (action) {
            try {
                action();
            }
            catch (error) {
                console.error("Error al ejecutar una acción pendiente después de la inicialización de FaceTec.", error);
            }
        });
    }
    function runAfterInitialization(callback) {
        if (isInitialized) {
            callback();
            return;
        }
        pendingInitializationActions.push(callback);
    }
    // Handle initialization unsuccess
    function onFaceTecSDKInitializationFailure(initializationError) {
        var _a;
        var errorCode = typeof initializationError === 'number'
            ? initializationError
            : ((_a = initializationError === null || initializationError === void 0 ? void 0 : initializationError.code) !== null && _a !== void 0 ? _a : Number(initializationError));
        var friendly = FaceTecStatusEnumFriendlyText.descriptionForInitializationError(initializationError);
        // Error 4 = recursos no cargaron. En WebViews a veces queda caché rota tras un deploy
        // (CSP/WASM malo). Un reload único suele desbloquear sin DevTools.
        var isResourcesError = errorCode === FaceTecSDK.FaceTecInitializationError.ResourcesCouldNotBeLoadedOnLastInit
            || String(initializationError) === '4';
        try {
            if (isResourcesError && sessionStorage.getItem('ft_resources_reload') !== '1') {
                sessionStorage.setItem('ft_resources_reload', '1');
                console.warn('⚠️ [FaceTec] ResourcesCouldNotBeLoadedOnLastInit — recargando una vez para limpiar caché WebView');
                window.location.reload();
                return;
            }
        }
        catch (e) { /* sessionStorage puede fallar en algunos WebViews */ }
        SampleAppUtilities.displayStatus("Initialization Failure.");
        logEvent('sdk_initialization_failure', {
            level: 'error',
            initializationError: {
                code: Number.isFinite(errorCode) ? errorCode : null,
                message: friendly,
                raw: String(initializationError)
            }
        });
    }
    ;
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed() {
        return __awaiter(this, arguments, void 0, function (isRetry) {
            var response, data, sessionRequestProcessor, facialResponse, facialData, sessionRequestProcessor, migrationProcessor, error_1, error_2;
            var _a, _b, _c, _d;
            if (isRetry === void 0) { isRetry = false; }
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        setCurrentTriggerFlow("verification");
                        if (!isRetry)
                            retryCount = 0;
                        logEvent('verification_started', { isRetry: isRetry, retryCount: retryCount });
                        window.showStepper('verification');
                        window.updateStepperProgress(1);
                        SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
                        latestExternalDatabaseRefID = generateExternalDatabaseRefID();
                        if (!latestExternalDatabaseRefID) {
                            logEvent('verification_aborted_no_enrolled_user', { level: 'error' });
                            alert("No hay usuarios enrolados. Por favor, primero realizar el proceso de enrolamiento.");
                            SampleAppUtilities.showMainUI();
                            SampleAppUtilities.enableAllButtons();
                            window.hideStepper();
                            return [2 /*return*/];
                        }
                        console.log("🔍 Verificando contra usuario enrollado:", latestExternalDatabaseRefID);
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 10, , 11]);
                        return [4 /*yield*/, fetch("".concat(Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT, "/enrollment-3d/").concat(encodeURIComponent(latestExternalDatabaseRefID)))];
                    case 2:
                        response = _e.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        data = _e.sent();
                        console.log("📋 Respuesta de enrollment-3d:", data);
                        if (!(data.success && data.faceMapBase64)) return [3 /*break*/, 4];
                        // Usuario existe en 3D DB → usar 3D vs 3D FaceMatch
                        console.log("Usando 3D-3D FaceMatch");
                        logEvent('verification_flow_decided', {
                            flow: '3d_3d_facematch',
                            enrollmentSource: '3d_db'
                        });
                        sessionRequestProcessor = new SessionRequestProcessor(latestExternalDatabaseRefID, onComplete);
                        markSessionStarted();
                        faceTecSDKInstance.start3DLivenessThen3DFaceMatch(sessionRequestProcessor);
                        return [3 /*break*/, 9];
                    case 4:
                        // Usuario NO existe en 3D DB → intentar migración 3D-2D con foto de ZiYU
                        console.log("Usando 3D-2D PhotoIDMatch");
                        logEvent('verification_flow_decided', {
                            flow: '3d_2d_photoidmatch_attempt',
                            enrollmentSource: 'ziyu_lookup'
                        });
                        _e.label = 5;
                    case 5:
                        _e.trys.push([5, 8, , 9]);
                        return [4 /*yield*/, fetch("".concat(Config.ZIYU_API_ENDPOINT, "access/api/get_user_facial_image/"), {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    user_rut: latestExternalDatabaseRefID,
                                    include_base64: true
                                })
                            })];
                    case 6:
                        facialResponse = _e.sent();
                        return [4 /*yield*/, facialResponse.json()];
                    case 7:
                        facialData = _e.sent();
                        console.log("\uD83D\uDCF8 Imagen facial - source: ".concat(facialData.source, ", base64 presente: ").concat(!!facialData.base64, ", largo: ").concat(((_a = facialData.base64) === null || _a === void 0 ? void 0 : _a.length) || 0));
                        if (!facialData.base64) {
                            // No hay foto de referencia → redirigir a enrolamiento con documento
                            console.warn("⚠️ No se encontró imagen facial en ZiYU, iniciando enrolamiento con documento...");
                            logEvent('verification_flow_decided', {
                                flow: 'fallback_enrollment_with_document',
                                reason: 'no_ziyu_facial_image',
                                ziyuSource: (_b = facialData.source) !== null && _b !== void 0 ? _b : null
                            });
                            // Cambiar stepper a flujo de enrolamiento
                            window.hideStepper();
                            window.showStepper('enroll');
                            window.updateStepperProgress(1);
                            // Cambiar trigger flow para que el log de cancelación sea correcto
                            setCurrentTriggerFlow("enrollment");
                            // Iniciar enrolamiento normal (liveness + escaneo documento)
                            // No hay enrollmentImageUrl en la URL, así que cae al flujo normal de SessionRequestProcessor
                            console.log("🔄 Iniciando enrolamiento con documento para:", latestExternalDatabaseRefID);
                            sessionRequestProcessor = new SessionRequestProcessor(latestExternalDatabaseRefID, onComplete);
                            markSessionStarted();
                            faceTecSDKInstance.start3DLivenessThen3D2DPhotoIDMatch(sessionRequestProcessor);
                            return [2 /*return*/];
                        }
                        // Hay foto → flujo de migración normal
                        logEvent('verification_flow_decided', {
                            flow: '3d_2d_photoidmatch_proceed',
                            ziyuSource: (_c = facialData.source) !== null && _c !== void 0 ? _c : null,
                            facialImageLength: ((_d = facialData.base64) === null || _d === void 0 ? void 0 : _d.length) || 0
                        });
                        migrationProcessor = new MigrationProcessor(latestExternalDatabaseRefID, facialData.base64, onComplete);
                        markSessionStarted();
                        faceTecSDKInstance.start3DLiveness(migrationProcessor);
                        return [3 /*break*/, 9];
                    case 8:
                        error_1 = _e.sent();
                        console.error("❌ Error obteniendo imagen facial:", error_1);
                        logEvent('ziyu_facial_image_error', {
                            level: 'error',
                            error: serializeErrorForLog(error_1)
                        });
                        alert("Error al obtener la imagen del usuario.");
                        SampleAppUtilities.showMainUI();
                        SampleAppUtilities.enableAllButtons();
                        window.hideStepper();
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_2 = _e.sent();
                        console.error("❌ Error verificando usuario:", error_2);
                        logEvent('verification_lookup_error', {
                            level: 'error',
                            error: serializeErrorForLog(error_2)
                        });
                        alert("Error al verificar el usuario. Por favor, intenta nuevamente.");
                        SampleAppUtilities.showMainUI();
                        SampleAppUtilities.enableAllButtons();
                        window.hideStepper();
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    }
    // ZIYU-12573: prueba de vida PURA (liveness-only) para el pre-registro web.
    // No enrola plantilla, no compara contra nada (refID vacío) y no crea FacialUser.
    // Aditiva: no toca onLivenessCheckPressed (verification) ni onEnrollUserPressed (enroll).
    function onLivenessOnlyPressed() {
        return __awaiter(this, arguments, void 0, function (isRetry) {
            var sessionRequestProcessor;
            if (isRetry === void 0) { isRetry = false; }
            return __generator(this, function (_a) {
                setCurrentTriggerFlow("liveness");
                if (!isRetry)
                    retryCount = 0;
                logEvent('liveness_started', { isRetry: isRetry, retryCount: retryCount });
                SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
                sessionRequestProcessor = new SessionRequestProcessor("", onComplete);
                markSessionStarted();
                faceTecSDKInstance.start3DLiveness(sessionRequestProcessor);
                return [2 /*return*/];
            });
        });
    }
    // Initiate a 3D Liveness enrollment with Photo ID Match.
    function onEnrollUserPressed() {
        return __awaiter(this, arguments, void 0, function (isRetry) {
            var urlParams, enrollmentImageUrl, imageBase64, migrationProcessor, error_3, sessionRequestProcessor;
            if (isRetry === void 0) { isRetry = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCurrentTriggerFlow("enrollment");
                        if (!isRetry)
                            retryCount = 0;
                        logEvent('enrollment_started', { isRetry: isRetry, retryCount: retryCount });
                        window.showStepper('enroll');
                        window.updateStepperProgress(1);
                        SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
                        latestExternalDatabaseRefID = generateExternalDatabaseRefID();
                        urlParams = new URLSearchParams(window.location.search);
                        enrollmentImageUrl = urlParams.get('enrollmentImageUrl');
                        if (!(enrollmentImageUrl && enrollmentImageUrl.trim() !== '')) return [3 /*break*/, 5];
                        console.log('🔄 [Migration] Detectado enrollmentImageUrl, iniciando flujo de migración');
                        console.log('📸 [Migration] URL de imagen:', enrollmentImageUrl.substring(0, 50) + '...');
                        logEvent('enrollment_flow_decided', {
                            flow: 'migration_with_external_image',
                            enrollmentImageUrlPrefix: enrollmentImageUrl.substring(0, 80)
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, downloadAndConvertImageToBase64(enrollmentImageUrl)];
                    case 2:
                        imageBase64 = _a.sent();
                        console.log('✅ [Migration] Imagen descargada y convertida a base64:', imageBase64.substring(0, 50) + '...');
                        migrationProcessor = new MigrationProcessor(latestExternalDatabaseRefID, imageBase64, onComplete);
                        console.log('🚀 [Migration] Iniciando 3D Liveness para migración');
                        markSessionStarted();
                        faceTecSDKInstance.start3DLiveness(migrationProcessor);
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        console.error('❌ [Migration] Error en flujo de migración:', error_3);
                        logEvent('migration_image_download_error', {
                            level: 'error',
                            enrollmentImageUrlPrefix: enrollmentImageUrl.substring(0, 80),
                            error: serializeErrorForLog(error_3)
                        });
                        alert('Error al procesar la imagen de migración. Por favor, intenta nuevamente.');
                        SampleAppUtilities.showMainUI();
                        SampleAppUtilities.enableAllButtons();
                        window.hideStepper();
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        // Normal enrollment flow with Photo ID Match
                        console.log('📝 [Enrollment] Flujo normal de enrollment con Photo ID Match');
                        logEvent('enrollment_flow_decided', { flow: 'normal_photoidmatch' });
                        sessionRequestProcessor = new SessionRequestProcessor(latestExternalDatabaseRefID, onComplete);
                        markSessionStarted();
                        faceTecSDKInstance.start3DLivenessThen3D2DPhotoIDMatch(sessionRequestProcessor);
                        console.log("sessionRequestProcessor", sessionRequestProcessor);
                        console.log("onFaceTecExit", sessionRequestProcessor.onFaceTecExit.toString());
                        console.log("faceTecSDKInstance", faceTecSDKInstance);
                        console.log("latestExternalDatabaseRefID", latestExternalDatabaseRefID);
                        console.log("faceTecSDKInstance", sessionRequestProcessor.demonstrationExternalDatabaseRefID);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    ;
    // Show the final result and transition back into the main interface.
    function onComplete(sessionStatus) {
        console.log("onComplete", sessionStatus);
        DeveloperStatusMessages.logSessionStatusOnFaceTecExit(sessionStatus);
        window.hideStepper();
        var userMessage = UserFriendlyMessages.getMessageForStatus(sessionStatus);
        var statusElement = document.getElementById("status");
        console.log("userMessage", userMessage);
        console.log("statusElement", statusElement);
        if (statusElement) {
            statusElement.className = '';
            statusElement.classList.add(userMessage.type);
        }
        // Resolución del nombre del enum FaceTecSessionStatus para que el log sea legible
        // (sessionStatus llega como número; con esto sabemos el caso exacto sin tener que mapearlo a mano).
        var sessionStatusName = (function () {
            try {
                var entries = Object.entries(FaceTecSDK.FaceTecSessionStatus);
                var found = entries.find(function (_a) {
                    var _ = _a[0], v = _a[1];
                    return v === sessionStatus;
                });
                return found ? found[0] : String(sessionStatus);
            }
            catch (_a) {
                return String(sessionStatus);
            }
        })();
        var sessionDurationMsTotal = sessionStartTime > 0 ? Date.now() - sessionStartTime : 0;
        var retryScreenCount = getSdkRetryScreenCount();
        var isSuccess = sessionStatus === FaceTecSDK.FaceTecSessionStatus.SessionCompleted;
        var isCancel = sessionStatus === FaceTecSDK.FaceTecSessionStatus.UserCancelledFaceScan ||
            sessionStatus === FaceTecSDK.FaceTecSessionStatus.UserCancelledIDScan;
        var finishedReason = isSuccess ? 'success' : (isCancel ? 'cancelled' : 'error');
        // Si llegamos a éxito tras al menos un retry, todos los retries fueron por
        // phantom-cancel (es la única razón por la que el código reintenta).
        var recoveredFromPhantomCancel = isSuccess && retryCount > 0;
        logEvent('session_finished', {
            level: isSuccess ? 'info' : 'error',
            triggerFlow: currentTriggerFlow,
            sessionStatus: sessionStatus,
            sessionStatusName: sessionStatusName,
            finishedReason: finishedReason,
            sessionDurationMs: sessionDurationMsTotal,
            retryCount: retryCount,
            retryScreenCount: retryScreenCount,
            recoveredFromPhantomCancel: recoveredFromPhantomCancel,
            hasValidationData: !!window.faceTecValidationData,
            hasAutentikarFormat: !!window.faceTecAutentikarFormat
        });
        // Evento dedicado para poder alertar/medir efectividad del workaround del retry.
        if (recoveredFromPhantomCancel) {
            logEvent('phantom_cancel_recovered', {
                level: 'info',
                triggerFlow: currentTriggerFlow,
                retryCount: retryCount,
                sessionDurationMs: sessionDurationMsTotal
            });
        }
        if (sessionStatus === FaceTecSDK.FaceTecSessionStatus.SessionCompleted) {
            // Save the enrolled user ID to localStorage if it was an enrollment
            if (latestExternalDatabaseRefID && latestExternalDatabaseRefID !== "") {
                localStorage.setItem('lastEnrolledUserID', latestExternalDatabaseRefID);
                console.log("✅ Usuario enrollado guardado:", latestExternalDatabaseRefID);
            }
            SampleAppUtilities.displayStatus(userMessage.text);
        }
        else {
            latestExternalDatabaseRefID = "";
            // Reintento automático solo si fue cancelación FANTASMA (sesión muy corta) y quedan reintentos
            var isCancelStatus = sessionStatus === FaceTecSDK.FaceTecSessionStatus.UserCancelledFaceScan ||
                sessionStatus === FaceTecSDK.FaceTecSessionStatus.UserCancelledIDScan;
            var sessionDurationMs = sessionStartTime > 0 ? Date.now() - sessionStartTime : 0;
            // Status 2 tras retry de calidad NO es tap fantasma: FaceTec cierra si no hubo
            // suficientes scans buenos ("cancelled before performing enough Scans").
            var isLikelyPhantomCancel = sessionDurationMs > 0 &&
                sessionDurationMs < PHANTOM_THRESHOLD_MS &&
                retryScreenCount === 0;
            if (isCancelStatus && isLikelyPhantomCancel && retryCount < MAX_RETRIES) {
                retryCount++;
                var cancelType = sessionStatus === FaceTecSDK.FaceTecSessionStatus.UserCancelledFaceScan
                    ? 'face_scan'
                    : 'id_scan';
                SampleAppUtilities.displayStatus("Reintentando en ".concat(RETRY_DELAY_MS / 1000, " segundos... (intento ").concat(retryCount, "/").concat(MAX_RETRIES, ")"));
                console.log("\uD83D\uDD04 [Retry] Cancelaci\u00F3n fantasma detectada (sesi\u00F3n ".concat(Math.round(sessionDurationMs / 1000), "s). Reintento ").concat(retryCount, "/").concat(MAX_RETRIES, " para flujo: ").concat(currentTriggerFlow));
                logEvent('phantom_cancel_retry_scheduled', {
                    level: 'info',
                    triggerFlow: currentTriggerFlow,
                    sessionStatus: sessionStatus,
                    sessionStatusName: sessionStatusName,
                    cancelType: cancelType,
                    sessionDurationMs: sessionDurationMs,
                    retryScreenCount: retryScreenCount,
                    phantomThresholdMs: PHANTOM_THRESHOLD_MS,
                    retryCount: retryCount,
                    maxRetries: MAX_RETRIES,
                    retryDelayMs: RETRY_DELAY_MS
                });
                setTimeout(function () {
                    if (currentTriggerFlow === "verification") {
                        onLivenessCheckPressed(true);
                    }
                    else if (currentTriggerFlow === "enrollment") {
                        onEnrollUserPressed(true);
                    }
                    else if (currentTriggerFlow === "liveness") {
                        onLivenessOnlyPressed(true); // ZIYU-12573
                    }
                }, RETRY_DELAY_MS);
                // No llamar showMainUI ni Flutter handler - el reintento se ejecutará
                SampleAppUtilities.enableAllButtons();
                return;
            }
            SampleAppUtilities.displayStatus(userMessage.text);
            // Log de cancelación si el usuario canceló el flujo
            if (isCancelStatus) {
                console.log("\uD83D\uDCDD [Cancel] ".concat(isLikelyPhantomCancel ? 'Fue fantasma pero sin reintentos' : 'Cancelación manual', " (sesi\u00F3n ").concat(Math.round(sessionDurationMs / 1000), "s)"));
                var cancelType = sessionStatus === FaceTecSDK.FaceTecSessionStatus.UserCancelledFaceScan
                    ? 'face_scan'
                    : 'id_scan';
                // Con esto distinguimos en el dashboard:
                //  - cancelación manual real (isLikelyPhantomCancel=false)
                //  - phantom cancel sin retries restantes (retriesExhausted=true)
                //  - phantom cancel única (retriesExhausted=false, retryCount=0)
                var retriesExhausted = isLikelyPhantomCancel && retryCount >= MAX_RETRIES;
                logEvent('session_cancelled', {
                    level: 'error',
                    triggerFlow: currentTriggerFlow,
                    sessionStatus: sessionStatus,
                    sessionStatusName: sessionStatusName,
                    cancelType: cancelType,
                    sessionDurationMs: sessionDurationMs,
                    retryScreenCount: retryScreenCount,
                    isLikelyPhantomCancel: isLikelyPhantomCancel,
                    retryCount: retryCount,
                    maxRetries: MAX_RETRIES,
                    retriesExhausted: retriesExhausted
                });
            }
        }
        // Llamar al handler de Flutter InAppWebView si está disponible
        try {
            if (window.flutter_inappwebview) {
                // Obtener datos de validación y autentikarFormat si existen
                var validationData = window.faceTecValidationData || null;
                var autentikarFormatData = window.faceTecAutentikarFormat || null;
                var completeData = {
                    sessionStatus: sessionStatus,
                    validation: validationData,
                    autentikarFormat: autentikarFormatData,
                    errorMessage: (validationData === null || validationData === void 0 ? void 0 : validationData.message) || userMessage.text
                };
                // Marcar el inminente cierre de la WebView como ESPERADO.
                // Flutter recibirá el callback y cerrará la vista, disparando pagehide/beforeunload.
                // Sin esto, cada cierre exitoso se reportaría como salida inesperada del usuario.
                var closeReason = isSuccess ? 'facetec_success'
                    : isCancel ? 'facetec_cancelled'
                        : 'facetec_error';
                try {
                    var mark = window.markSessionClosedExpected;
                    if (typeof mark === 'function') {
                        mark(closeReason, {
                            triggerFlow: currentTriggerFlow,
                            sessionStatus: sessionStatus,
                            sessionStatusName: sessionStatusName,
                            validationMessage: (validationData === null || validationData === void 0 ? void 0 : validationData.message) || null
                        });
                    }
                }
                catch (markErr) {
                    console.warn('⚠️ [SessionClose] No se pudo marcar cierre esperado:', markErr);
                    logEvent('session_close_mark_error', {
                        level: 'error',
                        error: serializeErrorForLog(markErr)
                    });
                }
                console.log("📱 [Flutter Bridge] Llamando a handler onComplete con datos:", JSON.stringify(completeData));
                logEvent('flutter_bridge_invoked', {
                    triggerFlow: currentTriggerFlow,
                    sessionStatusName: sessionStatusName,
                    closeReason: closeReason,
                    hasValidation: !!validationData,
                    hasAutentikarFormat: !!autentikarFormatData
                });
                window.flutter_inappwebview.callHandler('onComplete', completeData);
                // Limpiar la validación después de enviarla
                window.faceTecValidationData = null;
                window.faceTecAutentikarFormat = null;
            }
            else {
                console.log("No se encontró flutter_inappwebview");
                var env = detectEnvironment();
                // Solo es error real si la página se está ejecutando en un entorno donde
                // se ESPERA que Flutter haya inyectado el bridge (móvil / WebView).
                // En desktop (testing local desde Chrome/Edge) es comportamiento normal.
                logEvent('flutter_bridge_unavailable', {
                    level: env.expectedFlutterBridge ? 'error' : 'info',
                    triggerFlow: currentTriggerFlow,
                    sessionStatusName: sessionStatusName,
                    finishedReason: finishedReason,
                    isMobileUA: env.isMobileUA,
                    isLikelyWebView: env.isLikelyWebView,
                    expectedFlutterBridge: env.expectedFlutterBridge
                });
            }
        }
        catch (e) {
            console.error("❌ [Flutter Bridge] Error llamando handler:", e);
            logEvent('flutter_bridge_error', {
                level: 'error',
                triggerFlow: currentTriggerFlow,
                sessionStatusName: sessionStatusName,
                error: serializeErrorForLog(e)
            });
        }
        // ZIYU-12573: pre-registro web (liveness-only) -> senal al opener + redirect segun resultado.
        // Solo aplica al flujo liveness; NO afecta verification/enroll.
        if (currentTriggerFlow === "liveness") {
            try {
                var livenessMsg = { type: 'facetec_liveness_result', ok: isSuccess, status: sessionStatus };
                if (window.opener) {
                    window.opener.postMessage(livenessMsg, '*');
                }
                else if (window.parent !== window) {
                    window.parent.postMessage(livenessMsg, '*');
                }
            }
            catch (e) { /* noop */ }
            var livenessRedirect = new URLSearchParams(window.location.search).get('redirect');
            if (isSuccess && livenessRedirect) {
                window.location.href = livenessRedirect;
                return;
            }
        }
        SampleAppUtilities.showMainUI();
        SampleAppUtilities.enableAllButtons();
    }
    function generateExternalDatabaseRefID() {
        // Try to get RUT from URL parameters first
        var urlParams = new URLSearchParams(window.location.search);
        var rutFromUrl = urlParams.get('rut');
        if (rutFromUrl && rutFromUrl.trim() !== '') {
            console.log("✅ Usando RUT desde URL:", rutFromUrl);
            return rutFromUrl.trim();
        }
        // Fallback: Create a new externalDatabaseRefID
        console.log("⚠️ No se encontró RUT en URL, generando ID aleatorio");
        return "browser_sample_app_" + SampleAppUtilities.generateUUId();
    }
    ;
    function getLatestEnrollmentIdentifier() {
        return latestExternalDatabaseRefID;
    }
    // Helper function to download image from URL and convert to base64
    function downloadAndConvertImageToBase64(imageUrl) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log('📥 [Migration] Descargando imagen desde:', imageUrl.substring(0, 100) + '...');
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var img = new Image();
                        // Enable CORS for S3 images
                        img.crossOrigin = 'anonymous';
                        img.onload = function () {
                            try {
                                console.log('✅ [Migration] Imagen cargada exitosamente');
                                console.log('📐 [Migration] Dimensiones:', img.width, 'x', img.height);
                                // Create canvas to convert image to base64
                                var canvas = document.createElement('canvas');
                                canvas.width = img.width;
                                canvas.height = img.height;
                                var ctx = canvas.getContext('2d');
                                if (!ctx) {
                                    reject(new Error('No se pudo obtener contexto 2D del canvas'));
                                    return;
                                }
                                // Draw image on canvas
                                ctx.drawImage(img, 0, 0);
                                // Convert to base64
                                var base64 = canvas.toDataURL('image/jpeg');
                                console.log('✅ [Migration] Imagen convertida a base64 (length:', base64.length, ')');
                                resolve(base64);
                            }
                            catch (error) {
                                console.error('❌ [Migration] Error al convertir imagen a base64:', error);
                                reject(error);
                            }
                        };
                        img.onerror = function (error) {
                            console.error('❌ [Migration] Error al cargar imagen:', error);
                            reject(new Error('Error al cargar la imagen desde S3'));
                        };
                        // Start loading the image
                        img.src = imageUrl;
                    })];
            });
        });
    }
    return {
        onFaceTecSDKInitializationSuccess: onFaceTecSDKInitializationSuccess,
        onFaceTecSDKInitializationFailure: onFaceTecSDKInitializationFailure,
        onLivenessCheckPressed: onLivenessCheckPressed,
        onLivenessOnlyPressed: onLivenessOnlyPressed, // ZIYU-12573: prueba de vida (liveness-only) pre-registro web
        onComplete: onComplete,
        generateExternalDatabaseRefID: generateExternalDatabaseRefID,
        getLatestEnrollmentIdentifier: getLatestEnrollmentIdentifier,
        onEnrollUserPressed: onEnrollUserPressed,
        runAfterInitialization: runAfterInitialization,
    };
})();
